import React from 'react';

export default function ProjectDetails(props) {

  return (
    <div id={props.linkId} className="pdpt-container-center-horizontal">
      <div className="pdpt-x04-portfolio-detail-page-tablet">
        <h1 className="pdpt-title pdpt-valign-text-middle pdpt-typographyheadlineh4-extrabold-24">{props.projectName}</h1>
        <img 
        className="pdpt-rectangle-76" 
        src={props.bannerImage}
        />
        <div className="pdpt-text-1 pdpt-typography-body-smalltext-14-regular">
        <table>
          <tr>
            <th className="space">Name</th>
            <td className="align-left">{props.name}</td>
          </tr>
          <tr>
            <th className="space">Location</th>
            <td className="align-left">{props.location}</td>
          </tr>
          <tr>
            <th className="space">Project Type</th>
            <td className="align-left">{props.projectType}</td>
          </tr>
          <tr>
            <th className="space">Site Dimensions</th>
            <td className="align-left">{props.siteDimentions}</td>
          </tr>
          <tr>
            <th className="space">Project Direction</th>
            <td className="align-left">{props.projectDirection}</td>
          </tr>
          <tr>
            <th className="space">No. of Floors</th>
            <td className="align-left">{props.noOfFloors}</td>
          </tr>
          <tr>
            <th className="space">Details</th>
            <td className="align-left">{props.details}</td>
          </tr>
          <tr>
            <th className="space">Built Up Area</th>
            <td className="align-left">{props.builtUpArea}</td>
          </tr>
          <tr>
            <th className="space">Services</th>
            <td className="align-left">{props.services}</td>
          </tr>
          <tr>
            <th className="space">Project Value</th>
            <td className="align-left">{props.projectvalue}</td>
          </tr>
          <tr>
            <th className="space">Project Status</th>
            <td className="align-left">{props.projectstatus}</td>
          </tr>
        </table>
        </div>
        <div className="pdpt-frame-1615">
          <div className="pdpt-frame-1616">
            <div className="row">
              {
                props.PortfolioDetailCard.map(item => 
              <div className="column">
                <img 
                className="pdpt-rectangle-9" 
                src={item} 
                />
              </div>
                )}
              {/* <div className="column">
                <img 
                  className="pdpt-rectangle-9" 
                  src={props.PortfolioDetailCard2}
                />
              </div>
              <div className="column">
                <img 
                  className="pdpt-rectangle-9" 
                  src={props.PortfolioDetailCard3}
                />
              </div>
              <div className="column">
                <img 
                  className="pdpt-rectangle-9" 
                  src={props.PortfolioDetailCard4}
                />
              </div>
              <div className="column">
                <img 
                  className="pdpt-rectangle-9" 
                  src={props.PortfolioDetailCard5}
                />
              </div>
              <div className="column">
                <img 
                  className="pdpt-rectangle-9" 
                  src={props.PortfolioDetailCard6}
                />
              </div> */}
            </div>
          </div>
          <div className="pdpt-x27321357 component component-wrapper not-ready">
            <div className="pdpt-master-button-4Kvt1H">
              <div className="pdpt-button-i2732135751-k4dFab pdpt-valign-text-middle">{props.button}</div>
            </div>
          </div>
          <div className="pdpt-frame-161">
            <div className="pdpt-frame-180">
              <div className="pdpt-project-name pdpt-valign-text-bottom pdpt-typographyheadlineh5-extrabold-20">{props.projectName22}</div>
            </div>
            <div className="pdpt-group-181">
              <div className="pdpt-project-name-1 pdpt-valign-text-bottom pdpt-typographyheadlineh5-extrabold-20">{props.projectName32}</div>
            </div>
          </div>
        </div> 
      </div>
    </div>
  );
}
